import React from 'react';
import QRCode from 'qrcode.react';
import { useTranslation } from 'react-i18next';
import { FaEdit, FaCopy, FaDownload } from 'react-icons/fa';

const QRCodeGenerator = ({ maskedId, name, itemid, det }) => {
    const { t } = useTranslation();

    const trim_mask = Number(maskedId);
    const trim_id = Number(itemid);
    const qrData = `https://tinyurl.com/4p99zes8/${trim_id}/${trim_mask}/`;

    const downloadQRCodeAsPNG = () => {
        const svgElement = document.getElementById(`qrCodeSVG-${maskedId}`);
        if (!svgElement) return;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const svgData = new XMLSerializer().serializeToString(svgElement);
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const svgUrl = URL.createObjectURL(svgBlob);

        const img = new Image();
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(svgUrl);

            const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
            const link = document.createElement("a");
            link.href = pngUrl;
            link.download = `qrCode-${name}.png`;
            link.click();
        };
        img.src = svgUrl;
    };

    const downloadQRCodeAsSVG = () => {
        const svgElement = document.getElementById(`qrCodeSVG-${maskedId}`);
        if (!svgElement) return;
        const serializer = new XMLSerializer();
        const svgData = serializer.serializeToString(svgElement);
        const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
        const svgUrl = URL.createObjectURL(svgBlob);
        const link = document.createElement("a");
        link.href = svgUrl;
        link.download = `qrCode-${name}.svg`;
        link.click();
        URL.revokeObjectURL(svgUrl);
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(qrData).catch(err => console.error(err));
    };

    return (
        <div
            style={{
                width: '300px',
                backgroundColor: '#e6fff2',
                borderRadius: '14px',
                border: '1px solid #b8e6c3',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-4px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'none'}
        >
            {/* HEADER */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '14px 16px',
                    borderBottom: '1px solid #c3e6cb',
                    backgroundColor: '#daf1da',
                }}
            >
                <span
                    style={{
                        fontWeight: 600,
                        fontSize: '15px',
                        color: '#1e4620',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        maxWidth: '80%',
                    }}
                >
                    {name}
                </span>
                <button className="btn-icon-mint"
                    onClick={() => det(trim_mask)}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: '#2e7d32',
                        cursor: 'pointer',
                        fontSize: '18px',
                        opacity: 0.7,
                        transition: 'opacity 0.2s',
                    }}
                    title={t('edit')}
                    onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                    onMouseLeave={e => e.currentTarget.style.opacity = '0.7'}
                >
                    <FaEdit />
                </button>
            </div>

            {/* BODY – QR code */}
            <div
                style={{
                    backgroundColor: '#fff',
                    padding: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        border: '1px solid #c3e6cb',
                        borderRadius: '8px',
                        padding: '8px',
                    }}
                >
                    <QRCode
                        id={`qrCodeSVG-${maskedId}`}
                        value={qrData}
                        size={256}
                        level={"L"}
                        includeMargin={true}
                        renderAs="svg"
                        style={{ borderRadius: '4px' }}
                    />
                    <canvas
                        id={`qrCodeCanvas-${maskedId}`}
                        style={{ display: 'none' }}
                    />
                </div>
            </div>

            {/* FOOTER */}
            <div
                style={{
                    padding: '12px 16px',
                    borderTop: '1px solid #c3e6cb',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                {/* URL + copy */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <input
                        type="text"
                        value={qrData}
                        readOnly
                        style={{
                            flex: 1,
                            fontSize: '12px',
                            color: '#555',
                            border: '1px solid #c3e6cb',
                            borderRadius: '6px',
                            padding: '6px 8px',
                            backgroundColor: '#fff',
                        }}
                    />
                    <button className="btn-icon-mint"
                        onClick={copyToClipboard}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#2e7d32',
                            cursor: 'pointer',
                            fontSize: '16px',
                            padding: '4px',
                        }}
                        title={t('copy')}
                    >
                        <FaCopy />
                    </button>
                </div>

                {/* Download buttons */}
                <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                    <button className="btn-icon-mint"
                        onClick={downloadQRCodeAsPNG}
                        style={{
                            background: 'transparent',
                            border: '1px solid #2e7d32',
                            color: '#2e7d32',
                            borderRadius: '6px',
                            padding: '4px 12px',
                            fontSize: '13px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            cursor: 'pointer',
                        }}
                    >
                        <FaDownload /> PNG
                    </button>
                    <button className="btn-icon-mint"
                        onClick={downloadQRCodeAsSVG}
                        style={{
                            background: 'transparent',
                            border: '1px solid #2e7d32',
                            color: '#2e7d32',
                            borderRadius: '6px',
                            padding: '4px 12px',
                            fontSize: '13px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            cursor: 'pointer',
                        }}
                    >
                        <FaDownload /> SVG
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QRCodeGenerator;